import { createContext } from '@chakra-ui/react-utils';

export type ActionPreviewMode = 'approved' | 'rejected' | 'pending';

interface ActionPreviewContext {
  mode: ActionPreviewMode;
}

export const [ActionPreviewProvider, useActionPreviewContext] =
  createContext<ActionPreviewContext>({
    name: 'ActionPreviewContext',
    errorMessage:
      'useActionPreviewContext: `context` is undefined. Seems you used an ActionPreview sub-component outside of an `<ActionPreview />` wrapping box.',
  });
